import { statusTone } from '@repo/lib';

const CLASSES = {
  success: 'bg-success text-success-foreground',
  warning: 'bg-warning text-warning-foreground',
  destructive: 'bg-destructive/10 text-destructive',
  black: 'bg-foreground text-background',
  neutral: 'bg-secondary text-secondary-foreground',
};

export default status => ({ className: CLASSES[statusTone(status)] });
